<template>
  <section class="artist-spotlight" :class="{loading: loading}">
    <p class="artist-profile-label">ARTIST SPOTLIGHT</p>

    <div class="spotlight">
      <div class="spotlight-item" v-for="(artist, index) in randomArtists" :key="artist.id" :class="{ active: index === 0 }">
        <div class="artist-profile-bg" :style="'background-image:url(' + encodeURI(artistBackground(artist)) + ')'"></div>

        <div class="artist-profile-wrapper">
          <div class="artist-profile-content">
            <div class="artist-info">
              <h2 class="artist-title" :style="'font-size:' + titleFontSize(artist) + 'px;'"><template v-if="artist.tour_number">{{artist.tour_number}}. </template><span v-html="artist.name"></span></h2>
              <p class="mediums">{{artist.medium}}</p>
              <button class="btn" @click="$router.push(`/participants/${artist.id}`)">View Profile</button>
            </div>

            <a class="artist-icon" :style="'background-image:url(' + encodeURI(artistBackground(artist)) + ')'" @click="$router.push(`/participants/${artist.id}`)"></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      randomArtists: [],
      flickityDidInit: false,
    }
  },
  flickity: {},
  mounted() {
    this.randomArtists = this.getRandomArtists(this.$root.artists, 4);
    if (this.$route.name === 'intro') return;
    this.init();
  },
  activated() {
    if (!this.flickityDidInit) this.init();
  },
  methods: {
    init() {
      if (this.flickity) this.flickity.destroy();
      setTimeout(this.flickityInit, 100);
    },
    flickityInit() {
      this.flickityDidInit = true;
      this.flickity = new Flickity(this.$el.querySelector(".spotlight"), {
        cellAlign: "center",
        contain: true,
        prevNextButtons: false,
        autoPlay: 10000,
      });
      this.flickity.on("dragStart", function(event, pointer) {
        document.ontouchmove = function(e) {
          e.preventDefault();
        };
      });
      this.flickity.on("dragEnd", function(event, pointer) {
        restoreScroll();
      });

      let restoreScroll = () => {
        document.ontouchmove = function(e) {
          return true;
        };
      };
      restoreScroll();
      this.loading = false;
    },
    getRandomArtists(arr, count) {
      let shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      return shuffled.slice(min);
    },
    titleFontSize(artist) {
      let fontSize = 25;
      if (artist.name.length > 14) fontSize = 20;
      return fontSize;
    },
    artistBackground(artist) {
      if (artist.artwork[0]) return artist.artwork[0].images[0].image.url;
    },
  }
};
</script>

<style scoped lang="less">
@import '../css/variables';

.artist-spotlight {
  position: relative;
  overflow: hidden;
  color: #fff;
  background-color: #000;
  &.loading {
    opacity: 0;
  }
  .artist-profile-label {
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    padding: 7px 30px;
    z-index: 1;
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.27);
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: -15px;
      width: 0;
      height: 0;
      border-bottom: 30px solid transparent;
      border-left: 15px solid rgba(255, 255, 255, 0.27);
    }
  }

  .spotlight-item {
    width: 100vw;
    min-height: 100%;
    overflow: hidden;
    transform: translateZ(0);
  }
  .artist-profile-bg {
    position: absolute;
    top: -50px;
    right: -50px;
    bottom: -50px;
    left: -50px;
    filter: blur(31px);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    transform: translateZ(0);
    backface-visibility: hidden;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.14);
    }
  }

  .artist-profile-wrapper {
    position: relative;
    z-index: 1;
    padding-top: 50px;
  }
  .artist-profile-content {
    display: flex;
    justify-content: space-between;
    padding: 0 25px 65px 30px;
    .artist-info {
      max-width: calc(~"100% - 99px");
      padding-right: 10px;
      transform: translateZ(0);
    }
    .artist-title {
      overflow: hidden;
      font-family: @fontPrimary;
      font-size: 25px;
      font-weight: bold;
      line-height: 33px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .mediums {
      margin-bottom: 15px;
      overflow: hidden;
      white-space: nowrap;
      font-size: 15px;
      font-weight: 300;
      font-style: italic;
      text-overflow: ellipsis;
      text-transform: capitalize;
    }
    .btn {
      padding: 7px 30px;
    }
    .artist-icon {
      min-width: 99px;
      height: 99px;
      margin-top: -15px;
      background-size: cover;
      background-position: center;
      background-color: #1e1e1e;
      border-radius: 99px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    }
  }
}
</style>

<style lang="less">
.flickity-page-dots {
  bottom: 18px;
  .dot {
    width: 8px;
    height: 8px;
    opacity: 0.39;
    background: #fff;
    &.is-selected {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ArtistSpotlight.vue